var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuFavorite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#363636;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.43,110.51c-1.16,0-2.32-0.36-3.31-1.08c-1.75-1.27-2.61-3.38-2.24-5.51l4.57-26.65L17.09,58.38 c-1.55-1.51-2.09-3.72-1.43-5.78c0.67-2.05,2.41-3.52,4.55-3.84l26.76-3.89l11.97-24.25c0.96-1.94,2.89-3.14,5.05-3.14 s4.1,1.2,5.05,3.14l0,0l11.97,24.25l26.76,3.89c2.14,0.31,3.88,1.78,4.55,3.84c0.67,2.06,0.12,4.27-1.43,5.78L91.54,77.26 l4.57,26.65c0.37,2.13-0.49,4.24-2.24,5.51c-1.75,1.27-4.02,1.43-5.94,0.43L64,97.27l-23.94,12.58 C39.23,110.29,38.33,110.51,37.43,110.51z M64,90.09c0.9,0,1.8,0.22,2.62,0.65l22.12,11.63l-4.22-24.64 c-0.31-1.83,0.29-3.69,1.62-4.99l17.9-17.45l-24.74-3.59c-1.84-0.27-3.42-1.42-4.24-3.09L64,26.21L52.94,48.62 c-0.82,1.66-2.41,2.82-4.24,3.08L23.96,55.3l17.9,17.45c1.33,1.29,1.93,3.16,1.62,4.99l-4.22,24.63l22.12-11.63 C62.2,90.31,63.1,90.09,64,90.09z M81.34,45.53L81.34,45.53L81.34,45.53z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuFavorite);
export default __webpack_public_path__ + "static/media/menu-favorite.fd09aaead7902534945130f5cfadcc7a.svg";
export { ForwardRef as ReactComponent };